import React from 'react'
import ModalBody from '../modalbody'
import GetMaster from "../getmaster"

const TermsModal = ({modalHeading, master_id}) => {
    return (
        <ModalBody heading={modalHeading}>
            <div className="termscontent">
                <GetMaster id={master_id} />
            </div>
        </ModalBody>
    )
}

export default TermsModal
